import _ from 'underscore';
import styled from 'styled-components';

/**
 *
 * @param {*} settings: Array of objects of the form:
 * { label: String, isSet: bool, onClickHandler: func(newCheckBoxValue) void }
 */
export const SettingsList = ({ settings }) => {
  const listOfSettings = _.map(settings, (setting, index) => (
    <Setting key={index} label={setting.label} isSet={setting.isSet} onClickHandler={setting.onClickHandler} />
  ));

  return <div>{listOfSettings}</div>;
};

/**
 *
 * @param {*} label: Display Text
 * @param {*} isSet: Whether or not the check box is currently on
 * @param {*} onClickHandler: Function fired when check box is ticked
 *                            Accepts as an arg the new checkbox value.
 */
export const Setting = ({ label, isSet, onClickHandler, className }) => (
  <SettingWrapper className={className}>
    <SettingCheckbox onClickHandler={onClickHandler} isSet={isSet} />
    {label}
  </SettingWrapper>
);

export const SettingCheckbox = ({ isSet, onClickHandler, className, required, name }) => (
  <StyledSettingCheckbox
    type="checkbox"
    required={!!required}
    name={name}
    className={className}
    onChange={() => onClickHandler && onClickHandler(!isSet)}
    checked={isSet}
  />
);

const StyledSettingCheckbox = styled.input`
  margin-right: 10px;
  height: 15px;
`;

const SettingWrapper = styled.div`
  padding-top: 0.5rem;
  margin-bottom: 0.2rem;
`;
